import {Component, OnInit} from '@angular/core';
import {AvaliacaoService} from "../../services/avaliacao.service";

@Component({
  selector: 'app-tela-lista-avaliacoes',
  templateUrl: './tela-lista-avaliacoes.component.html',
  styleUrls: ['./tela-lista-avaliacoes.component.scss']
})
export class TelaListaAvaliacoesComponent implements OnInit {
  avaliacoes: Array<any> = [];
  total = 0;
  loading = false;
  erro = '';
  inicio = 0;
  tamanhoPagina = 10;
  paginas: Array<number> = [];
  estrelas = [1, 2, 3, 4, 5];
  modoGrupoLojas = false;
  notaMediaUltimos30Dias: any = {
    qtdeAvaliacoes: 0,
    media: 0,
  };
  notaGeral: any = {
    qtdeAvaliacoes: 0,
    media: 0,
  };

  opcoesNota = [5, 4, 3, 2, 1];
  opcoesEntrega = [
    {valor: '', descricao: 'Todas'},
    {valor: 'gostou', descricao: 'Gostou'},
    {valor: 'naoGostou', descricao: 'Não gostou'},
  ];
  opcoesPeriodo = [
    {valor: '', descricao: 'Todo o período'},
    {valor: '7', descricao: 'Últimos 7 dias'},
    {valor: '30', descricao: 'Últimos 30 dias'},
    {valor: '90', descricao: 'Últimos 90 dias'},
  ];
  opcoesOrdem = [
    {valor: '', descricao: 'Mais recentes'},
    {valor: 'antigas', descricao: 'Mais antigas'},
    {valor: 'maiorNota', descricao: 'Maior nota'},
    {valor: 'menorNota', descricao: 'Menor nota'},
  ];
  opcoesNaLoja = [
    {valor: '', descricao: 'Todas'},
    {valor: 'sim', descricao: 'Na loja'},
    {valor: 'nao', descricao: 'Fora da loja'},
  ];
  opcoesPublicarAutomatico = [
    {valor: null as number, descricao: 'Desligado'},
    {valor: 5, descricao: 'Só 5'},
    {valor: 4, descricao: '4 ou mais'},
    {valor: 3, descricao: '3 ou mais'},
  ];
  ordem = '';
  filtro = {
    termo: '',
    nota: null as number,
    entrega: '',
    dias: '',
    comentario: false,
    naLoja: '',
  };
  publicacao = {
    carregada: false,
    salvando: false,
    erro: '',
    notaMinima: null as number,
    resumoPublico: {media: 0, total: 0},
  };
  private timerBusca: any;

  constructor(private avaliacaoService: AvaliacaoService) { }

  ngOnInit(): void {
    this.carregue(0);
    this.carregueConfiguracaoPublicacao();
  }

  get paginaAtual() {
    return Math.floor(this.inicio / this.tamanhoPagina) + 1;
  }

  get totalPaginas() {
    return Math.ceil(this.total / this.tamanhoPagina);
  }

  get ultimoItemDaPagina() {
    return Math.min(this.inicio + this.tamanhoPagina, this.total);
  }

  get temFiltro() {
    return !!(this.filtro.termo || this.filtro.nota || this.filtro.entrega || this.filtro.dias || this.filtro.comentario ||
      this.filtro.naLoja);
  }

  vaParaPagina(pagina: number) {
    if (pagina < 1 || pagina > this.totalPaginas || pagina === this.paginaAtual) return;

    this.carregue((pagina - 1) * this.tamanhoPagina);
  }

  digitouBusca() {
    clearTimeout(this.timerBusca);
    this.timerBusca = setTimeout(() => this.carregue(0), 400);
  }

  escolhaNota(nota: number) {
    this.filtro.nota = this.filtro.nota === nota ? null : nota;
    this.carregue(0);
  }

  escolhaEntrega(entrega: string) {
    this.filtro.entrega = entrega;
    this.carregue(0);
  }

  escolhaNaLoja(naLoja: string) {
    this.filtro.naLoja = naLoja;
    this.carregue(0);
  }

  alterneComentario() {
    this.filtro.comentario = !this.filtro.comentario;
    this.carregue(0);
  }

  limpeFiltros() {
    this.filtro = {termo: '', nota: null, entrega: '', dias: '', comentario: false, naLoja: ''};
    this.carregue(0);
  }

  carregue(inicio: number) {
    clearTimeout(this.timerBusca);
    this.inicio = inicio;
    this.loading = true;
    this.erro = '';

    this.avaliacaoService.liste(this.inicio, this.tamanhoPagina, this.obtenhaFiltrosDaBusca()).then( (respAvaliacoes) => {
      this.loading = false;
      if (!respAvaliacoes) {
        return
      }

      this.notaGeral = respAvaliacoes.notaMediaGeral;
      this.notaMediaUltimos30Dias = respAvaliacoes.notaMediaUltimos30Dias;
      this.avaliacoes = respAvaliacoes.avaliacoes || [];
      this.total = respAvaliacoes.total || 0;
      this.paginas = this.monteListaDePaginas();
    }).catch( (erro) => {
      this.loading = false;
      this.erro = typeof erro === 'string' ? erro : 'Não foi possível carregar as avaliações.';
    });
  }

  get explicacaoRegra() {
    const notaMinima = this.publicacao.notaMinima;

    if (!notaMinima) return 'Nada vai para a loja sozinho. Publique na lista abaixo as avaliações que quiser mostrar.';
    if (notaMinima === 5) return 'Toda avaliação de 5 estrelas aparece na loja, com o comentário. As outras ficam só aqui.';

    return `Avaliações com ${notaMinima} estrelas ou mais aparecem na loja, com o comentário. As outras ficam só aqui.`;
  }

  carregueConfiguracaoPublicacao() {
    this.avaliacaoService.obtenhaConfiguracaoPublicacao().then((configuracao: any) => {
      this.publicacao.carregada = true;
      this.publicacao.notaMinima = configuracao?.notaMinima || null;
      this.publicacao.resumoPublico = configuracao?.resumoPublico || {media: 0, total: 0};
    }).catch(() => {
      this.publicacao.carregada = true;
    });
  }

  escolhaPublicarAutomatico(notaMinima: number) {
    if (this.publicacao.salvando || notaMinima === this.publicacao.notaMinima) return;

    const anterior = this.publicacao.notaMinima;
    this.publicacao.notaMinima = notaMinima;
    this.publicacao.salvando = true;
    this.publicacao.erro = '';

    this.avaliacaoService.salveConfiguracaoPublicacao(notaMinima).then(() => {
      this.publicacao.salvando = false;
      this.carregueConfiguracaoPublicacao();
      this.carregue(this.inicio);
    }).catch((erro) => {
      this.publicacao.salvando = false;
      this.publicacao.notaMinima = anterior;
      this.publicacao.erro = typeof erro === 'string' ? erro : 'Não foi possível salvar. Tente de novo.';
    });
  }

  descricaoEstadoNaLoja(avaliacao: any) {
    if (avaliacao.estadoNaLoja === 'AUTOMATICA') return 'Na loja · pela regra';
    if (avaliacao.estadoNaLoja === 'MANUAL') return 'Na loja · você publicou';
    if (avaliacao.publicacao === 'OCULTA') return 'Fora da loja · você tirou';

    return 'Fora da loja';
  }

  // publicacao: 'PUBLICADA', 'OCULTA' ou null (volta a seguir a regra).
  altereVisibilidade(avaliacao: any, publicacao: string) {
    if (avaliacao.salvandoPublicacao) return;

    avaliacao.salvandoPublicacao = true;
    avaliacao.erroPublicacao = '';

    this.avaliacaoService.altereVisibilidade(avaliacao, publicacao).then((resposta: any) => {
      avaliacao.salvandoPublicacao = false;
      avaliacao.publicacao = resposta.publicacao;
      avaliacao.estadoNaLoja = resposta.estadoNaLoja;
      this.carregueConfiguracaoPublicacao();
    }).catch((erro) => {
      avaliacao.salvandoPublicacao = false;
      avaliacao.erroPublicacao = typeof erro === 'string' ? erro : 'Não foi possível alterar. Tente de novo.';
    });
  }

  percentualEstrelas(media: number) {
    return Math.max(0, Math.min(100, (Number(media) || 0) / 5 * 100));
  }

  iniciais(nome: string) {
    const partes = (nome || '').trim().split(/\s+/).filter((parte) => parte);

    if (!partes.length) return '?';
    if (partes.length === 1) return partes[0].charAt(0).toUpperCase();

    return (partes[0].charAt(0) + partes[partes.length - 1].charAt(0)).toUpperCase();
  }

  tempoParaAvaliar(avaliacao: any) {
    return (avaliacao.tempoAvaliarDescricao || '').replace('há ', '').replace('em ', '');
  }

  private obtenhaFiltrosDaBusca() {
    const filtros: any = {};

    if (this.filtro.termo.trim()) filtros.termo = this.filtro.termo.trim();
    if (this.filtro.nota) filtros.nota = this.filtro.nota;
    if (this.filtro.entrega) filtros.entrega = this.filtro.entrega;
    if (this.filtro.dias) filtros.dias = this.filtro.dias;
    if (this.filtro.comentario) filtros.comentario = true;
    if (this.filtro.naLoja) filtros.naLoja = this.filtro.naLoja;
    if (this.ordem) filtros.ordem = this.ordem;

    return filtros;
  }

  // Páginas visíveis: primeira, última e vizinhas da atual; 0 marca reticências.
  private monteListaDePaginas() {
    const total = this.totalPaginas;
    const atual = this.paginaAtual;
    const paginas: Array<number> = [];

    for (let pagina = 1; pagina <= total; pagina++) {
      if (pagina === 1 || pagina === total || Math.abs(pagina - atual) <= 1) {
        paginas.push(pagina);
      } else if (paginas[paginas.length - 1] !== 0) {
        paginas.push(0);
      }
    }

    return paginas;
  }
}
